import { bl_inv_pdg_outlet_size_filter_link_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryPdgOutletSizeFilterLinkContainerModel extends BaseContainerModel {
  bl_inv_pdg_outlet_size_filter_link: bl_inv_pdg_outlet_size_filter_link_RowClass = new bl_inv_pdg_outlet_size_filter_link_RowClass();
}
